// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.documents-grid.documents-grid-inline {
  display: grid !important;
  grid-template-columns: repeat(3, 1fr) !important;
  gap: 12px !important;
  flex-direction: unset !important;
}

.documents-grid.documents-grid-inline.documents-grid-smaller {
  grid-template-columns: repeat(6, 1fr) !important;
  gap: 8px !important;
}

@media (max-width: 1200px) {
  .documents-grid.documents-grid-inline.documents-grid-smaller {
    grid-template-columns: repeat(4, 1fr) !important;
  }
}

@media (max-width: 768px) {
  .documents-grid.documents-grid-inline.documents-grid-smaller {
    grid-template-columns: repeat(2, 1fr) !important;
  }
}

.documents-grid.documents-grid-fullWidth {
  display: grid !important;
  grid-template-columns: 1fr !important;
  gap: 12px !important;
}

.document-card {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start !important;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #dfdfdf;
  cursor: pointer;
  transition:
    background-color 0.2s,
    transform 0.2s;
  padding: 12px 16px;
}

.document-card-inline {
  width: 100%;
}

.document-card-fullWidth {
  width: 100%;
}

.document-card:hover {
  background-color: #d0d0d0;
  transform: translateY(-2px);
}

.document-left {
  display: flex;
  align-items: flex-start !important;
  gap: 10px;
}

.document-left .document-info {
  align-items: flex-start !important;
  gap: 0;
}

.document-left .document-info .document-type {
  margin: 0;
}

.documents-list .document-card {
  justify-content: flex-start;
}

.document-icon {
  width: 32px;
  height: 32px;
  color: #555;
  background: transparent !important;
}

.document-info {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.document-type {
  font-weight: 500;
  font-size: 1.5rem !important;
  color: #222;
  background: transparent !important;
  padding: 0 !important;
  text-align: start !important;
}

.document-date {
  font-size: 12px;
  color: #777;
  margin-top: 0.25rem;
}

.document-actions {
  display: flex;
  gap: 8px;
}

.document-actions button {
  border-radius: 12px;
  cursor: pointer;
  margin-top: 1.5rem;
}

.dl-button-icon-white {
  fill: white !important;
  /* stroke: white !important; */
}

/* Loader pour les documents */
.document-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  padding-right: 16px;
}

.document-loading-centered {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 40px;
}

.spinner {
  width: 24px;
  height: 24px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #555;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content-document {
  background: white;
  padding: 20px;
  border-radius: 12px;
  width: 90%;
  max-width: 800px;
  max-height: 90%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.documents-list {
  margin: 2rem 0;
}

/* Variante smaller */
.document-card-smaller {
  padding: 6px !important;
  min-height: 0 !important;
}

.document-card-smaller .document-left {
  gap: 6px;
}

.document-icon-smaller {
  width: 20px;
  height: 20px;
}

.document-type-smaller {
  font-size: 1.2rem !important;
}

.document-date-smaller {
  font-size: 10px;
}

.spinner-smaller {
  width: 16px;
  height: 16px;
  border-width: 2px;
}

.document-card-smaller .document-left .document-info {
  align-items: center !important;
}
`, "",{"version":3,"sources":["webpack://./src/composants/DocumentsList/DocumentsList.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,gDAAgD;EAChD,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,wBAAwB;EACxB,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,kCAAkC;EAClC,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf;;kBAEgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,MAAM;AACR;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,WAAW;EACX,kCAAkC;EAClC,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC","sourcesContent":[".documents-grid.documents-grid-inline {\r\n  display: grid !important;\r\n  grid-template-columns: repeat(3, 1fr) !important;\r\n  gap: 12px !important;\r\n  flex-direction: unset !important;\r\n}\r\n\r\n.documents-grid.documents-grid-inline.documents-grid-smaller {\r\n  grid-template-columns: repeat(6, 1fr) !important;\r\n  gap: 8px !important;\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n  .documents-grid.documents-grid-inline.documents-grid-smaller {\r\n    grid-template-columns: repeat(4, 1fr) !important;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .documents-grid.documents-grid-inline.documents-grid-smaller {\r\n    grid-template-columns: repeat(2, 1fr) !important;\r\n  }\r\n}\r\n\r\n.documents-grid.documents-grid-fullWidth {\r\n  display: grid !important;\r\n  grid-template-columns: 1fr !important;\r\n  gap: 12px !important;\r\n}\r\n\r\n.document-card {\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  align-items: flex-start !important;\r\n  border: 1px solid #ddd;\r\n  border-radius: 8px;\r\n  background-color: #dfdfdf;\r\n  cursor: pointer;\r\n  transition:\r\n    background-color 0.2s,\r\n    transform 0.2s;\r\n  padding: 12px 16px;\r\n}\r\n\r\n.document-card-inline {\r\n  width: 100%;\r\n}\r\n\r\n.document-card-fullWidth {\r\n  width: 100%;\r\n}\r\n\r\n.document-card:hover {\r\n  background-color: #d0d0d0;\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.document-left {\r\n  display: flex;\r\n  align-items: flex-start !important;\r\n  gap: 10px;\r\n}\r\n\r\n.document-left .document-info {\r\n  align-items: flex-start !important;\r\n  gap: 0;\r\n}\r\n\r\n.document-left .document-info .document-type {\r\n  margin: 0;\r\n}\r\n\r\n.documents-list .document-card {\r\n  justify-content: flex-start;\r\n}\r\n\r\n.document-icon {\r\n  width: 32px;\r\n  height: 32px;\r\n  color: #555;\r\n  background: transparent !important;\r\n}\r\n\r\n.document-info {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-start;\r\n}\r\n\r\n.document-type {\r\n  font-weight: 500;\r\n  font-size: 1.5rem !important;\r\n  color: #222;\r\n  background: transparent !important;\r\n  padding: 0 !important;\r\n  text-align: start !important;\r\n}\r\n\r\n.document-date {\r\n  font-size: 12px;\r\n  color: #777;\r\n  margin-top: 0.25rem;\r\n}\r\n\r\n.document-actions {\r\n  display: flex;\r\n  gap: 8px;\r\n}\r\n\r\n.document-actions button {\r\n  border-radius: 12px;\r\n  cursor: pointer;\r\n  margin-top: 1.5rem;\r\n}\r\n\r\n.dl-button-icon-white {\r\n  fill: white !important;\r\n  /* stroke: white !important; */\r\n}\r\n\r\n/* Loader pour les documents */\r\n.document-loading {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin-left: auto;\r\n  padding-right: 16px;\r\n}\r\n\r\n.document-loading-centered {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 100%;\r\n  min-height: 40px;\r\n}\r\n\r\n.spinner {\r\n  width: 24px;\r\n  height: 24px;\r\n  border: 3px solid #f3f3f3;\r\n  border-top: 3px solid #555;\r\n  border-radius: 50%;\r\n  animation: spin 0.8s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.modal-content-document {\r\n  background: white;\r\n  padding: 20px;\r\n  border-radius: 12px;\r\n  width: 90%;\r\n  max-width: 800px;\r\n  max-height: 90%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n}\r\n\r\n.modal-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 12px;\r\n}\r\n\r\n.documents-list {\r\n  margin: 2rem 0;\r\n}\r\n\r\n/* Variante smaller */\r\n.document-card-smaller {\r\n  padding: 6px !important;\r\n  min-height: 0 !important;\r\n}\r\n\r\n.document-card-smaller .document-left {\r\n  gap: 6px;\r\n}\r\n\r\n.document-icon-smaller {\r\n  width: 20px;\r\n  height: 20px;\r\n}\r\n\r\n.document-type-smaller {\r\n  font-size: 1.2rem !important;\r\n}\r\n\r\n.document-date-smaller {\r\n  font-size: 10px;\r\n}\r\n\r\n.spinner-smaller {\r\n  width: 16px;\r\n  height: 16px;\r\n  border-width: 2px;\r\n}\r\n\r\n.document-card-smaller .document-left .document-info {\r\n  align-items: center !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
